import "./src/styles/global.css"
import "./src/styles/react-modal.css"
import "./src/styles/swiper-slider.css"
import "tailwindcss/dist/base.min.css"